import { PageLayout } from "../layout";
import React from "react";
import { observer } from "mobx-react";
import { ResetPasswordForm } from "../../auth";
import { useLoaderData } from "react-router";

export const ResetPasswordPage = observer(() => {
  const { token } = useLoaderData() as { token: string | null };

  return (
    <PageLayout>
      <ResetPasswordForm token={token} />
    </PageLayout>
  );
});
